<div class="swiper-outer-navs o-prev" *ngIf="showOuterNavs && gallery?.length>7">
  <button (click)="prev()" mat-icon-button><mat-icon>chevron_left</mat-icon></button>
</div>
<div *ngIf="gallery" #swiper [id]="slideType" [swiper]="swiperconfig" class="swiper-container gallery-top {{config?.theme}}" [ngClass]="{'overflow': slideType=='leaderboard'}" (indexChange)="onIndexChange($event)">
  <div *ngIf="config?.fundraiser?.beneficiary?.tax_benefit && config?.theme.match('v1')" class="tax_exempt">
    <div class="taxContainer">
      <span class="taxRibbon" *ngIf="isMobile">
        Tax benefit
        <span class="tooltipContainer">
          &nbsp;<i class="material-icons info-icon">info</i>
        </span>
      </span>
      <div class="tax-benefit" *ngIf="!isMobile">
        <div class="taxt-container">
          <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax benefit ribbon" />
        </div>
      </div>
    </div>
    <span class="tooltipText">80G Tax Exemption Certificate Available</span>
  </div>
  <div class="days-left" *ngIf="isMobile && config?.fundraiser?.end_date && !config?.isFundraiserEnded && !config?.fundraiser?.settings?.hidedaysleft && config?.theme.match('v1')">
    <i class="icon-stopwatch icomoon"></i>{{config?.fundraiser?.end_date | dayjs:'diffInDays'}} Days Left
  </div>
  <div [id]="'lightgallery' + slideType" class="swiper-wrapper">
    <a *ngFor="let slide of galleryfilter; let i = index;" [href]="slideType=='leaderboard'? domSanitizer.bypassSecurityTrustResourceUrl('javascript:void(0)') :slide.cdn_path" [attr.data-sub-html]="slide?.detail_1" class="swiper-slide img-container">
      <!-- For images -->
      <img loading="lazy" [hidden]="slide.media_type==='video'" class="img"
          [ngClass]="slideType" src="/assets/images/transparent.png" [attr.data-src]="slide.cdn_path" defaultImg="blur" [alt]="'Fundraiser Leaderboard'+i" />
      <!-- For Youtube video -->
      <img loading="lazy" [hidden]="!(slide.media_type=='video' && !slide?.showVideo)" class="img"
          [ngClass]="slideType" [attr.data-src]="slide.cdn_path" (click)="addYoutubeEmbed(slide)" [alt]="'Fundraiser Leaderboard Youtube Video'+i" />
      <i *ngIf="slide.media_type=='video' && !slide?.showVideo" class="icon-youtube1" (click)="addYoutubeEmbed(slide)"></i>
      <!-- Youtube embed -->
      <iframe *ngIf="slide.media_type=='video' && slide?.showVideo" class="youtube-embed b-lazy"
              [ngClass]="slideType" type="text/html" allow="autoplay" [src]="slide?.videoSrc"></iframe>
      <!-- Under line shadow -->
      <div *ngIf="shadow" class="image-shadow" [attr.data-bg]="slide.cdn_path"></div>
      <!-- Fundraiser Short Description for desktop-->
      <div class="fr-short-description" *ngIf="!isMobile && basicInfo && !slide?.showVideo && !config?.theme.match('v1')">{{basicInfo?.about}}</div>
      <div class="fr-short-description" *ngIf="!isMobile && config?.theme.match('v1')">{{config?.fundraiser?.story_title?.info_1}}</div>
    </a>
    <span class="ketto-verified-fos" *ngIf="isFOS">
      <app-ketto-assured></app-ketto-assured>
      <!-- <img loading="lazy" data-src="/assets/images/ketto-verifiedTag.png" alt="ketto verified image badge"> -->
    </span>
  </div>
  <!-- Navigation buttons -->
  <div class="swiper-scrollbar" *ngIf="swiperconfig.scrollbar"></div>
  <div class="swiper-pagination" *ngIf="swiperconfig.pagination"></div>
  <div *ngIf="gallery && gallery?.length>1">
    <div class="swiper-button-prev" (click)="prev()" *ngIf="swiperconfig.navigation && showNavs"></div>
    <div class="swiper-button-next" (click)="next()" *ngIf="swiperconfig.navigation && showNavs"></div>
  </div>
</div>
<div class="swiper-outer-navs o-next" *ngIf="showOuterNavs && gallery?.length>6">
  <button (click)="next()" mat-icon-button><mat-icon>chevron_right</mat-icon></button>
</div>

<div *ngIf="hasThumbs" class="thumbnail-area">
  <div class="thumbs-container">
    <div class="swiper-container gallery-thumbs" *ngIf="!isMobile && gallery && gallery?.length>1"  [swiper]="thumbConfig">
      <div class="swiper-wrapper">
        <div class="swiper-slide" *ngFor="let slide of gallery; let i = index">
          <img loading="lazy" class="img" [attr.data-src]="slide.cdn_path"
            [ngClass]="{'active-thumb':currentIndex==i}" (click)="thumbsOnClick(i)" [alt]="'Fundraiser Leaderboard Thumbnails'+i" />
        </div>
      </div>
      <div class="swiper-button-prev" *ngIf="gallery?.length>4"></div>
      <div class="swiper-button-next" *ngIf="gallery?.length>4"></div>
    </div>
  </div>

  <div class="share-fundraiser-container d-none d-sm-inline-block" *ngIf="hasThumbs">
    <!-- Socail Share -->
    <app-social-share shareType="menu"></app-social-share>
  </div>
</div>
